import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentAnalytics = ({ plays, quizzes, glossaryTerms }) => {
  const getPopularityColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-accent';
    if (score >= 40) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <Icon name="Theater" size={20} color="white" />
          </div>
          <h3 className="text-lg font-semibold text-card-foreground">Popular Plays</h3>
        </div>
        <div className="space-y-4">
          {plays?.map((play, index) => (
            <div key={play?.id} className="flex items-center gap-3">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center text-sm font-semibold text-muted-foreground">
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-card-foreground truncate">{play?.title}</p>
                <p className="text-xs text-muted-foreground">{play?.interactions?.toLocaleString()} interactions</p>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-16 bg-muted rounded-full h-2 overflow-hidden">
                  <div
                    className={`h-full rounded-full ${getPopularityColor(play?.popularity)}`}
                    style={{ width: `${play?.popularity}%`, backgroundColor: 'currentColor' }}
                  />
                </div>
                <span className={`text-xs font-semibold ${getPopularityColor(play?.popularity)}`}>
                  {play?.popularity}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center">
            <Icon name="BookOpen" size={20} color="white" />
          </div>
          <h3 className="text-lg font-semibold text-card-foreground">Quiz Performance</h3>
        </div>
        <div className="space-y-4">
          {quizzes?.map((quiz) => (
            <div key={quiz?.id} className="border border-border rounded-lg p-4">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="text-sm font-medium text-card-foreground">{quiz?.title}</p>
                  <p className="text-xs text-muted-foreground mt-1">{quiz?.completions} completions</p>
                </div>
                <div className={`flex items-center gap-1 ${quiz?.avgScore >= 80 ? 'text-success' : quiz?.avgScore >= 60 ? 'text-accent' : 'text-warning'}`}>
                  <Icon name={quiz?.avgScore >= 80 ? 'TrendingUp' : quiz?.avgScore >= 60 ? 'Minus' : 'TrendingDown'} size={14} />
                  <span className="text-sm font-semibold">{quiz?.avgScore}%</span>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">Average Score</span>
                  <span className="font-medium text-card-foreground">{quiz?.avgScore}%</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                  <div
                    className={`h-full rounded-full ${quiz?.avgScore >= 80 ? 'bg-success' : quiz?.avgScore >= 60 ? 'bg-accent' : 'bg-warning'}`}
                    style={{ width: `${quiz?.avgScore}%` }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center">
            <Icon name="BookText" size={20} color="white" />
          </div>
          <h3 className="text-lg font-semibold text-card-foreground">Glossary Usage</h3>
        </div>
        <div className="space-y-4">
          {glossaryTerms?.map((term, index) => (
            <div key={term?.id} className="flex items-center gap-3">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center text-sm font-semibold text-muted-foreground">
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-card-foreground">{term?.word}</p>
                <p className="text-xs text-muted-foreground">{term?.lookups?.toLocaleString()} lookups</p>
              </div>
              <div className="flex items-center gap-1 text-accent">
                <Icon name="Eye" size={14} />
                <span className="text-xs font-semibold">{term?.lookups}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentAnalytics;